import { createContext } from 'react';
import { decorate, observable, action } from 'mobx';

import * as fn from '../utilities/_functions';
import api from '../api';

export class ExternalDoctorUpdate {
    id = null;
    data = null;
    originalData = null;
    isReady = false;
    isSaving = false;
    isLoading = false;
    hasUnsavedChanges = false;

    cancelExternalDoctorGet = null;
    cancelExternalDoctorUpdate = null;

    initialize = (id) => {
        const that = this;
        this.clear();

        that.id = id;
        that.isLoading = true;

        return new Promise((resolve, reject) => {
            api.ExternalDoctors.get(id, (c) => { that.cancelExternalDoctorGet = c; })
                .then(({ data }) => {
                    that.originalData = data;
                    that.data = data;
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    that.isLoading = false;
                    that.isReady = true;
                })
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            if (that.hasUnsavedChanges) {
                api.ExternalDoctors.update(that.id, that.data, (c) => { that.cancelExternalDoctorUpdate = c })
                    .then(() => {
                        that.hasUnsavedChanges = false;
                        resolve(that.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            } else {
                that.hasUnsavedChanges = false;
                that.isSaving = false;
                resolve();
            }
        })
    }

    delete = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            api.ExternalDoctors.delete(that.id, (c) => { that.cancelExternalDoctorUpdate = c })
                .then(() => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    that.isSaving = false;
                })
        })
    }

    clear = () => {
        this.id = null;
        this.originalData = null;
        this.data = null;
        this.isReady = false;
        this.isSaving = false;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelExternalDoctorGet)) {
            this.cancelExternalDoctorGet();
            this.cancelExternalDoctorGet = null;
        }

        if (fn.isFunction(this.cancelExternalDoctorUpdate)) {
            this.cancelExternalDoctorUpdate();
            this.cancelExternalDoctorUpdate = null;
        }
    }
}

decorate(ExternalDoctorUpdate, {
    id: observable,
    originalData: observable.deep,
    data: observable.deep,
    isReady: observable,
    isSaving: observable,
    hasUnsavedChanges: observable,
    initialize: action,
    save: action,
    delete: action,
    clearAddress: action,
    clear: action,
})

export default createContext(new ExternalDoctorUpdate());